var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Collection, Property } from '@syncfusion/ej2-base';
import { LabelItem } from './label-item';
/**
 * Configures settings related to Label popup in the editor.
 * This property utilizes the LabelSettingsModel to specify various options and behaviors for paste operations.
 */
export class LabelSettings extends ChildProperty {
}
__decorate([
    Collection([], LabelItem)
], LabelSettings.prototype, "items", void 0);
__decorate([
    Property('$')
], LabelSettings.prototype, "triggerChar", void 0);
